import React from "react";
import { useState } from "react";

import imageOne from "../../../assets/lesson 6.1.png";
import imageTwo from "../../../assets/lesson 5.2.png";

function LessonEight() {
  const [q1, setQ1] = useState("");
  const [q2, setQ2] = useState("");
  const [q3, setQ3] = useState("");
  const [q4, setQ4] = useState("");
  const [q5, setQ5] = useState("");
  const [q6, setQ6] = useState("");
  const [q7, setQ7] = useState("");
  const [q8, setQ8] = useState("");
  const [q9, setQ9] = useState("");
  const [q10, setQ10] = useState("");
  const [q11, setQ11] = useState("");
  const [q12, setQ12] = useState("");
  const [q13, setQ13] = useState("");
  const [q14, setQ14] = useState("");
  const [q15, setQ15] = useState("");
  const [q16, setQ16] = useState("");
  const [q17, setQ17] = useState("");
  const [q18, setQ18] = useState("");
  const [q19, setQ19] = useState("");
  const [q20, setQ20] = useState("");
  const [q21, setQ21] = useState("");
  const [q22, setQ22] = useState("");
  const [q23, setQ23] = useState("");
  const [q24, setQ24] = useState("");
  const [q25, setQ25] = useState("");
  const [q26, setQ26] = useState("");
  const [q27, setQ27] = useState("");
  const [q28, setQ28] = useState("");
  const [q29, setQ29] = useState("");
  const [q30, setQ30] = useState("");
  const [q31, setQ31] = useState("");
  const [q32, setQ32] = useState("");
  const [q33, setQ33] = useState("");
  const [q34, setQ34] = useState("");
  const [q35, setQ35] = useState("");
  const [q36, setQ36] = useState("");
  const [q37, setQ37] = useState("");
  const [q38, setQ38] = useState("");
  const [q39, setQ39] = useState("");
  const [q40, setQ40] = useState("");
  return (
    <>
      <div className="">
        <div className="task-one mb-3">
          <h4>
            <span>8.1</span> Write questions with <strong> Do...? </strong>and
            <strong> Does...? </strong>.
          </h4>
          <p className="table row">
            <ol className="">
              <li>
                I like chocolate. How about you?
                <input
                  className="border"
                  value="Do you like chocolate"
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
                ?
              </li>
              <li>
                I play tennis. How about you?
                <input
                  className="border"
                  onChange={(e) => setQ1(e.target.value)}
                  style={{
                    background: q1.trim() === "Do" ? "#198754" : "white",
                    color: q1.trim() === "Do" ? "white" : "black",
                  }}
                />
                you
                <input
                  className="border"
                  onChange={(e) => setQ2(e.target.value)}
                  style={{
                    background:
                      q2.trim() === "play tennis" ? "#198754" : "white",
                    color: q2.trim() === "play tennis" ? "white" : "black",
                  }}
                />
                ?
              </li>
              <li>
                You live near here. How about Lucy?
                <input
                  className="border"
                  onChange={(e) => setQ3(e.target.value)}
                  style={{
                    background: q3.trim() === "Does" ? "#198754" : "white",
                    color: q3.trim() === "Does" ? "white" : "black",
                  }}
                />
                Lucy
                <input
                  className="border"
                  onChange={(e) => setQ4(e.target.value)}
                  style={{
                    background:
                      q4.trim() === "live near here" ? "#198754" : "white",
                    color: q4.trim() === "live near here" ? "white" : "black",
                  }}
                />
                ?
              </li>
              <li>
                Tom plays tennis. How about his friends?
                <input
                  className="border"
                  onChange={(e) => setQ5(e.target.value)}
                  style={{
                    background:
                      q5.trim() === "Do they play tennis" ? "#198754" : "white",
                    color:
                      q5.trim() === "Do they play tennis" ? "white" : "black",
                  }}
                />
                ?
              </li>
              <li>
                You speak English. How about your brother?
                <input
                  className="border"
                  onChange={(e) => setQ6(e.target.value)}
                  style={{
                    background:
                      q6.trim() === "Does he speak English"
                        ? "#198754"
                        : "white",
                    color:
                      q6.trim() === "Does he speak English" ? "white" : "black",
                  }}
                />
                ?
              </li>
              <li>
                I do yoga every morning. How about you?
                <input
                  className="border"
                  onChange={(e) => setQ7(e.target.value)}
                  style={{
                    background:
                      q7.trim() === "Do you do yoga every morning?"
                        ? "#198754"
                        : "white",
                    color:
                      q7.trim() === "Do you do yoga every morning?"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                Sue goes away a lot. How about Paul?
                <input
                  className="border"
                  onChange={(e) => setQ8(e.target.value)}
                  style={{
                    background:
                      q8.trim() === "Does he go away a lot"
                        ? "#198754"
                        : "white",
                    color:
                      q8.trim() === "Does he go away a lot" ? "white" : "black",
                  }}
                />
                ?
              </li>
              <li>
                I want to be famous. How about you?
                <input
                  className="border"
                  onChange={(e) => setQ9(e.target.value)}
                  style={{
                    background:
                      q9.trim() === "Do you want to be famous"
                        ? "#198754"
                        : "white",
                    color:
                      q9.trim() === "Do you want to be famous"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                You work hard. How about Anna?
                <input
                  className="border"
                  onChange={(e) => setQ10(e.target.value)}
                  style={{
                    background:
                      q10.trim() === "Does she work hard" ? "#198754" : "white",
                    color:
                      q10.trim() === "Does she work hard" ? "white" : "black",
                  }}
                />
                ?
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-two mb-3">
          <h4>
            <span>8.2</span> Make questions from these words +{" "}
            <strong>do / does.</strong> Put the words in the right order.
          </h4>
          <p className="table row">
            {/* <ul className="border d-flex justify-content-evenly">
              <li>eat</li>
              <li>go</li>
              <li>live</li>
              <li className="strike">play</li>
              <li>play</li>
              <li>sleep</li>
            </ul> */}

            <ol className="">
              <li>
                (where / live / your parents)
                <input
                  className="border"
                  value="Where do your parents live"
                  disabled
                  onChange={(e) => setQ6(e.target.value)}
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                ?
              </li>
              <li>
                (you / early / always / get up)
                <input
                  className="border"
                  value="Do you always get up early"
                  style={{
                    background: "#198754",
                    color: "white",
                  }}
                />
                ?
              </li>
              <li>
                (how often / TV / you / watch)
                <input
                  className="border"
                  onChange={(e) => setQ7(e.target.value)}
                  style={{
                    background:
                      q7.trim() === "How often do you watch TV"
                        ? "#198754"
                        : "white",
                    color:
                      q7.trim() === "How often do you watch TV"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (you / want / what / for dinner)
                <input
                  className="border"
                  onChange={(e) => setQ8(e.target.value)}
                  style={{
                    background:
                      q8.trim() === "What do you want for dinner"
                        ? "#198754"
                        : "white",
                    color:
                      q8.trim() === "What do you want for dinner"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (like / you / football)
                <input
                  className="border"
                  onChange={(e) => setQ9(e.target.value)}
                  style={{
                    background:
                      q9.trim() === "Do you like football"
                        ? "#198754"
                        : "white",
                    color:
                      q9.trim() === "Do you like football" ? "white" : "black",
                  }}
                />
                ?
              </li>
              <li>
                (your brother / like / football)
                <input
                  className="border"
                  onChange={(e) => setQ10(e.target.value)}
                  style={{
                    background:
                      q10.trim() === "Does your brother like football"
                        ? "#198754"
                        : "white",
                    color:
                      q10.trim() === "Does your brother like football"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (what / you / do / in your free time)
                <input
                  className="border"
                  onChange={(e) => setQ11(e.target.value)}
                  style={{
                    background:
                      q11.trim() === "What do you do in your free time"
                        ? "#198754"
                        : "white",
                    color:
                      q11.trim() === "What do you do in your free time"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (your sister / work / where)
                <input
                  className="border"
                  onChange={(e) => setQ12(e.target.value)}
                  style={{
                    background:
                      q12.trim() === "Where does your sister work"
                        ? "#198754"
                        : "white",
                    color:
                      q12.trim() === "Where does your sister work"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (breakfast / always / you / have)
                <input
                  className="border"
                  onChange={(e) => setQ13(e.target.value)}
                  style={{
                    background:
                      q13.trim() === "Do you always have breakfast"
                        ? "#198754"
                        : "white",
                    color:
                      q13.trim() === "Do you always have breakfast"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (what / mean / this word)
                <input
                  className="border"
                  onChange={(e) => setQ14(e.target.value)}
                  style={{
                    background:
                      q14.trim() === "What does this word mean"
                        ? "#198754"
                        : "white",
                    color:
                      q14.trim() === "What does this word mean"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (in winter / snow / it / here)
                <input
                  className="border"
                  onChange={(e) => setQ15(e.target.value)}
                  style={{
                    background:
                      q15.trim() === "Does it snow in winter here"
                        ? "#198754"
                        : "white",
                    color:
                      q15.trim() === "Does it snow in winter here"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (go / usually / to bed / what time / you)
                <input
                  className="border"
                  onChange={(e) => setQ16(e.target.value)}
                  style={{
                    background:
                      q16.trim() === "What time do you usually go to bed"
                        ? "#198754"
                        : "white",
                    color:
                      q16.trim() === "What time do you usually go to bed"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
              <li>
                (you / for breakfast / have / usually / what)
                <input
                  className="border"
                  onChange={(e) => setQ17(e.target.value)}
                  style={{
                    background:
                      q17.trim() === "What do you usually have for breakfast"
                        ? "#198754"
                        : "white",
                    color:
                      q17.trim() === "What do you usually have for breakfast"
                        ? "white"
                        : "black",
                  }}
                />
                ?
              </li>
            </ol>
          </p>
        </div>

        <hr />

        <div className="task-three mb-3 row ">
          <h4>
            <span>8.3</span> Complete the questions. Use these verbs:
          </h4>
          <p className="table row">
            <ul className="border d-flex justify-content-evenly">
              <li className="strike">do</li>
              <li>do</li>
              <li>enjoy</li>
              <li>go</li>
              <li>like</li>
              <li>start</li>
              <li>teach</li>
              <li>work</li>
            </ul>
            <div className="row">
              <ol
                className="col-xsm-12 col-sm-12 col-md-7 col-lg-7 col-xlg-7 text-end"
                style={{ minWidth: "fit-content" }}
              >
                <li>
                  What
                  <input
                    className="border"
                    value="do you do"
                    disabled
                    style={{
                      background: "#198754",
                      color: "white",
                    }}
                  />
                  ?
                </li>
                <li>
                  
                  <input
                    className="border"
                    onChange={(e) => setQ18(e.target.value)}
                    style={{
                      background:
                        q18.trim() === "Do you like" ? "#198754" : "white",
                      color: q18.trim() === "Do you like" ? "white" : "black",
                    }}
                  />
                  it.
                </li>
                <li>
                  What time
                  <input
                    className="border"
                    onChange={(e) => setQ19(e.target.value)}
                    style={{
                      background:
                        q19.trim() === "does it start" ? "#198754" : "white",
                      color: q19.trim() === "does it start" ? "white" : "black",
                    }}
                  />
                  in the morning?
                </li>
                <li>
                  <input
                    className="border"
                    onChange={(e) => setQ20(e.target.value)}
                    style={{
                      background:
                        q20.trim() === "Do you work" ? "#198754" : "white",
                      color: q20.trim() === "Do you work" ? "white" : "black",
                    }}
                  />
                  on Saturdays?
                </li>
                <li>
                  How
                  <input
                    className="border"
                    onChange={(e) => setQ21(e.target.value)}
                    style={{
                      background:
                        q21.trim() === "do you go" ? "#198754" : "white",
                      color: q21.trim() === "do you go" ? "white" : "black",
                    }}
                  />
                  to work?
                </li>
                <li>
                  And your husband. What
                  <input
                    className="border"
                    onChange={(e) => setQ22(e.target.value)}
                    style={{
                      background:
                        q22.trim() === "does he do" ? "#198754" : "white",
                      color: q22.trim() === "does he do" ? "white" : "black",
                    }}
                  />
                  ?
                </li>
                <li>
                  What
                  <input
                    className="border"
                    onChange={(e) => setQ23(e.target.value)}
                    style={{
                      background:
                        q23.trim() === "does he teach" ? "#198754" : "white",
                      color: q23.trim() === "does he teach" ? "white" : "black",
                    }}
                  />
                  ?
                </li>
                <li>
                  <input
                    className="border"
                    onChange={(e) => setQ24(e.target.value)}
                    style={{
                      background:
                        q24.trim() === "Does he like"
                          ? "#198754"
                          : "white",
                      color:
                        q24.trim() === "Does he like"
                          ? "white"
                          : "black",
                    }}
                  />
                  his job?
                </li>
              </ol>
              <ul className="col-xsm-12 col-sm-12 col-md-3 col-lg-3 col-xlg-3 border">
                <li className="my-2">I work in a bookshop.</li>
                <li className="my-2">It's OK.</li>
                <li className="my-2">At 9 o'clock.</li>
                <li className="my-2">Sometimes.</li>
                <li className="my-2">Usually by bus.</li>
                <li className="my-2">He's a teacher.</li>
                <li className="my-2">Science.</li>
                <li className="my-2">Yes, he loves it.</li>
              </ul>
            </div>
          </p>
        </div>

        <hr />

        <div className="task-four mb-3">
          <h4>
            <span>8.4</span> Write short answers (
            <strong>Yes, he does. / No, I don't.</strong> etc.).
          </h4>
          <p className="table row">
            <ol className="border">
              <li>
                Do you watch TV a lot?
                <input
                  className="border"
                  value="No, I don't."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
                or
                <input
                  className="border"
                  value="Yes, I do."
                  disabled
                  style={{ background: "#198754", color: "white" }}
                />
              </li>
              <li>
                Do you live in a big city?
                <input
                  className="border"
                  onChange={(e) => setQ25(e.target.value)}
                  style={{
                    background:
                      q25.trim() === "Yes, I do."
                        ? "#198754"
                        : q25.trim() === "No, I don't."
                        ? "#198754"
                        : "white",
                    color:
                      q25.trim() === "Yes, I do."
                        ? "white"
                        : q25.trim() === "No, I don't."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Do you often ride a bike?
                <input
                  className="border"
                  onChange={(e) => setQ26(e.target.value)}
                  style={{
                    background:
                      q26.trim() === "Yes, I do."
                        ? "#198754"
                        : q26.trim() === "No, I don't."
                        ? "#198754"
                        : "white",
                    color:
                      q26.trim() === "Yes, I do."
                        ? "white"
                        : q26.trim() === "No, I don't."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Does it rain a lot where you live?
                <input
                  className="border"
                  onChange={(e) => setQ27(e.target.value)}
                  style={{
                    background:
                      q27.trim() === "Yes, it does."
                        ? "#198754"
                        : q27.trim() === "No, it doesn't."
                        ? "#198754"
                        : "white",
                    color:
                      q27.trim() === "Yes, it does."
                        ? "white"
                        : q27.trim() === "No, it doesn't."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
              <li>
                Do you play the piano?
                <input
                  className="border"
                  onChange={(e) => setQ28(e.target.value)}
                  style={{
                    background:
                      q28.trim() === "Yes, I do."
                        ? "#198754"
                        : q28.trim() === "No, I don't."
                        ? "#198754"
                        : "white",
                    color:
                      q28.trim() === "Yes, I do."
                        ? "white"
                        : q28.trim() === "No, I don't."
                        ? "white"
                        : "black",
                  }}
                />
              </li>
            </ol>
          </p>
        </div>
      </div>
    </>
  );
}

export default LessonEight;
